(() => {
  const selector = ':is(ha-mask-product,hg-mask-product,hb-mask-product,pp-pad-product,jc-cream-product) details.ha-faq';
  if (window.QuiaFaqMotion) {
    window.QuiaFaqMotion.init(document);
    return;
  }

  const states = new WeakMap();
  const active = new Set();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const duration = 340;
  const easing = 'cubic-bezier(.4,0,.2,1)';

  function cancel(state) {
    const animation = state.animation;
    state.animation = null;
    if (animation) animation.cancel();
    if (state.contentAnimation) state.contentAnimation.cancel();
    state.contentAnimation = null;
  }

  function settle(state) {
    cancel(state);
    state.details.open = state.expanded;
    state.details.style.height = state.height;
    state.details.style.overflow = state.overflow;
    state.answer.inert = !state.expanded;
  }

  function expand(state, expanded) {
    if (expanded && state.group) {
      for (const peer of active) {
        if (peer !== state && peer.group === state.group && peer.expanded && peer.details.isConnected) {
          expand(peer, false);
        }
      }
    }

    const startHeight = state.details.getBoundingClientRect().height;
    const opacity = state.contentAnimation ? getComputedStyle(state.answer).opacity : (state.details.open ? '1' : '0');
    cancel(state);
    state.expanded = expanded;
    state.details.dataset.faqExpanded = String(expanded);
    state.summary.setAttribute('aria-expanded', String(expanded));
    state.answer.inert = !expanded;

    if (reducedMotion.matches || typeof state.details.animate !== 'function') {
      settle(state);
      return;
    }

    // Keep native details open during collapse so its answer can animate out.
    state.details.open = true;
    state.details.style.height = state.height;
    const style = getComputedStyle(state.details);
    const endHeight = expanded ? state.details.getBoundingClientRect().height :
      state.summary.getBoundingClientRect().height +
      parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) +
      parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);

    state.details.style.height = `${startHeight}px`;
    state.details.style.overflow = 'hidden';
    const animation = state.details.animate([
      {height: `${startHeight}px`},
      {height: `${endHeight}px`}
    ], {duration, easing, fill: 'both'});
    state.animation = animation;
    state.contentAnimation = state.answer.animate([
      {opacity}, {opacity: expanded ? 1 : 0}
    ], {duration: expanded ? duration : 240, easing, fill: 'both'});
    animation.onfinish = () => {
      if (state.animation === animation) settle(state);
    };
  }

  function init(root) {
    for (const details of root.querySelectorAll(selector)) {
      if (states.has(details)) continue;
      const summary = details.querySelector(':scope > summary');
      const answer = details.querySelector(':scope > .ha-answer');
      if (!summary || !answer) continue;
      const state = {
        details, summary, answer,
        group: details.getAttribute('name'),
        expanded: details.open,
        height: details.style.height,
        overflow: details.style.overflow,
        animation: null,
        contentAnimation: null
      };
      // Manage named groups here so the previous answer also closes smoothly.
      if (state.group) details.removeAttribute('name');
      states.set(details, state);
      active.add(state);
      details.dataset.faqMotion = 'true';
      details.dataset.faqExpanded = String(state.expanded);
      summary.setAttribute('aria-expanded', String(state.expanded));
      answer.inert = !state.expanded;
      summary.addEventListener('click', event => {
        if (event.target.closest('a,button,input,select,textarea')) return;
        event.preventDefault();
        expand(state, !state.expanded);
      });
      // The card owns its outer padding; forward that area through the same animation.
      details.addEventListener('click', event => {
        if (event.target !== details || window.getSelection()?.toString()) return;
        event.preventDefault();
        expand(state, !state.expanded);
      });
      details.addEventListener('toggle', () => {
        if (state.animation) return;
        state.expanded = details.open;
        details.dataset.faqExpanded = String(state.expanded);
        summary.setAttribute('aria-expanded', String(state.expanded));
        answer.inert = !state.expanded;
      });
    }
  }

  window.QuiaFaqMotion = {init};
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const state of active) {
      if (event.target.contains(state.details)) {
        settle(state);
        active.delete(state);
      }
    }
  });
  window.addEventListener('resize', () => {
    for (const state of active) if (state.animation) settle(state);
  }, {passive: true});
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) for (const state of active) if (state.animation) settle(state);
  });
})();
